<template>
    <svg role="img" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 13.25 14" fill="none" aria-label="Overview view icon">
        <rect x="0.625" y="1" width="12" height="12" rx="1" stroke="currentColor" stroke-width="1.25" />
        <path d="M3.625 10L3.625 4" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" />
        <path d="M6.625 10L6.625 4" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" />
        <path d="M9.625 10L9.625 4" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" />
    </svg>
</template>
